import { observer } from "mobx-react"
import { Button, Flex, Typography } from "antd"
import { choose } from "choose-matching"

import { authStore } from "@src/app/authStore"
import { IdItem } from "@src/app/components/tableRowItems/idItem"
import uiStore from "@src/app/uiStore"
import css from "../index.module.css"

export const GenerateKYBLink = observer(() => {
  const { fetchKybUrl, isLoading, kybLink } = authStore
  const { isTransferioTheme } = uiStore()

  return (
    <Flex
      align="center"
      className={css.kybWrapper}
      gap={16}
      justify="center"
      vertical
    >
      <Flex gap={16} style={{ marginTop: "auto" }} vertical>
        <Flex align="center" className={css.kybText} vertical>
          <Typography.Title className={css.kybTitle}>-OR-</Typography.Title>
          <Typography.Title className={css.kybSubtitle}>
            GET STRAIGHT TO BUSSINESS
          </Typography.Title>
          <Typography.Text>
            Ready to move forward? Fill out the online form to begin onboarding
          </Typography.Text>
        </Flex>
        {choose(
          [
            Boolean(kybLink),
            <Flex className={css.kybInputWrap} justify="center">
              <Flex className={css.kybInput}>
                <IdItem
                  className={css.kybInputId}
                  id={kybLink as string}
                  onClick={() =>
                    kybLink ? window.open(kybLink, "_blank") : () => false
                  }
                  p={12}
                />
              </Flex>
            </Flex>,
          ],
          [
            true,
            <Button
              className={css.kybButton}
              id="GENERATED_ID_GENERATEKYBLINK_BUTTON_GENERATE_THE_UNIQUE_1"
              loading={isLoading}
              onClick={fetchKybUrl}
              size="large"
              style={{ margin: "24px 0" }}
              type="primary"
            >
              Generate the unique KYB link
            </Button>,
          ],
        )}
      </Flex>

      <Flex
        align="center"
        gap={4}
        style={{
          fontSize: 12,
          marginTop: "auto",
          textAlign: "center",
        }}
        vertical
      >
        <Typography.Text style={{ color: "#7E7E7E" }}>
          Learn more about our API{" "}
          <Typography.Link
            href={
              isTransferioTheme
                ? "https://developers.transferio.io"
                : "https://developers.cryptix.io/"
            }
            rel="noopener noreferrer"
            target="_blank"
            underline
          >
            documentation
          </Typography.Link>
        </Typography.Text>

        <Typography.Text style={{ color: "#7E7E7E" }}>
          Do you have any questioins? Contact us via Telegram{" "}
          <Typography.Link
            href="https://t.me/cryptix_chat"
            rel="noopener noreferrer"
            target="_blank"
            underline
          >
            @cryptix_chat
          </Typography.Link>
        </Typography.Text>
      </Flex>
    </Flex>
  )
})
